import { Copy, Ellipsis, Pencil, Trash2 } from "lucide-react";

import { buttonVariants } from "@/components/ui/button";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";

export function TagTableActions({
  tag,
  canEditTag = false,
  canDeleteTag = false,
  onEditTag = () => {},
  onCloneTag = () => {},
  onDeleteTag = () => {},
}) {
  if (!canEditTag && !canDeleteTag) {
    return null;
  }

  return (
    <DropdownMenu>
      <DropdownMenuTrigger
        aria-label="Tag actions"
        className={buttonVariants({ variant: "ghost", size: "icon-sm" })}
      >
        <Ellipsis />
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="tw:w-auto">
        {canEditTag && (
          <>
            <DropdownMenuItem onClick={() => onEditTag(tag)}>
              <Pencil />
              Edit Tag
            </DropdownMenuItem>
            <DropdownMenuItem onClick={() => onCloneTag(tag)}>
              <Copy />
              Clone Tag
            </DropdownMenuItem>
          </>
        )}
        {canDeleteTag && (
          <DropdownMenuItem
            variant="destructive"
            onClick={() => onDeleteTag(tag)}
          >
            <Trash2 />
            Delete Tag
          </DropdownMenuItem>
        )}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
